import clsx from 'clsx';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { LocaleContext } from '../Layout';

type Props = { className?: string; darkBg: boolean };

export const NewChip = ({ className, darkBg }: Props): JSX.Element => {
  const locale = useContext(LocaleContext);
  return (
    <span
      className={twMerge(
        clsx(
          'h-fit rounded-4 bg-black bg-opacity-35 px-6 py-2 text-xs leading-gripped text-white md:text-xs lg:text-xs',
          darkBg && 'bg-white bg-opacity-20',
          className,
        ),
      )}
    >
      {{ en: 'New', fr: 'Nouveau' }[locale]}
    </span>
  );
};
